import React from 'react';
import { format } from 'date-fns';

import { DispensationItemInterface, PrescriptionItemInterface } from '../../../../interfaces/prescription';
import { PermissionsInterface } from '../../../../interfaces/drugstore';

import Subtitle from '../../../ui/Subtitle';
import Spinner from '../../../ui/Spinner';

import * as Styles from './CancellationStyles';

interface Props {
  items: PrescriptionItemInterface[];
  cancelDispensation: Function;
  loadingItem: number | boolean;
  permissions: PermissionsInterface;
}

const Cancellation: React.FC<Props> = ({ items, cancelDispensation, loadingItem, permissions }: Props) => {
  if (items.length === 0) {
    return <></>;
  }

  const checkOwner = (dispensation: DispensationItemInterface): boolean => {
    const authenticatedChainId = permissions.current_drugstore ? permissions.current_drugstore.chain.id : null;

    const dispensationChainId = dispensation.drugstore ? dispensation.drugstore.chain_id : null;

    return dispensationChainId === authenticatedChainId;
  };

  return (
    <>
      <Styles.Container>
        <Subtitle>Itens dispensados</Subtitle>
        <Styles.List>
          {items.map((item) => item.dispensation.data
            .filter((dispensationItem) => dispensationItem.status !== 'blocked')
            .map((dispensationItem) => (
              <Styles.Row key={dispensationItem.id}>
                <Styles.ItemName>{item.name}</Styles.ItemName>
                <span>{format(dispensationItem.date, 'dd/MM/yyyy HH:mm:ss')}</span>
                <Styles.Actions>
                  {checkOwner(dispensationItem) && (
                    <>
                      <Styles.Button
                        className="tracking-cancel-dispensation"
                        onClick={() => cancelDispensation(dispensationItem.id)}
                        size="small"
                        hoverColor="alert"
                        disabled={loadingItem === dispensationItem.id}
                      >
                        {loadingItem && loadingItem === dispensationItem.id ? <Spinner size="14px" /> : 'Cancelar'}
                      </Styles.Button>
                      <Styles.Link
                        aria-disabled={!item.dispensation.document.url}
                        className={`tracking-download-pdf-dispensation-item${
                          !item.dispensation.document.url ? ' disabled-link' : ''
                        }`}
                        download={!item.dispensation.document.url}
                        href={!item.dispensation.document.url ? `/#/` : item.dispensation.document.url}
                        onClick={(e) => (!item.dispensation.document.url ? e.preventDefault() : '')}
                        target="_blank"
                        title={
                          item.dispensation.document.url
                            ? `Clique para realizar o download do PDF do medicamento ${item.name}`
                            : `O medicamento ${item.name} não dispõe de PDF para download`
                        }
                      >
                        Baixar prescrição individual
                      </Styles.Link>
                    </>
                  )}
                </Styles.Actions>
              </Styles.Row>
            )),
          )}
        </Styles.List>
      </Styles.Container>
    </>
  );
};

export default Cancellation;
